import {FC} from 'react'

import {Button} from '@/components/common/content/Button'
import {ButtonSize} from '@/components/common/content/ButtonTypes'
import {Link} from '@/i18n'
import {analytics} from '@/utils/tracking/analytics'
import {CardContentButtonType} from '@/utils/user-portal/types'

type CardContentButtonProps = {
  button: CardContentButtonType
}

export const CardContentButton: FC<CardContentButtonProps> = ({button}) => {
  const {
    text,
    variant,
    size = ButtonSize.small,
    icon,
    linkHref,
    textColor,
    fontWeight,
    isFullWidth,
    isHoverable,
    openInNewTab,
    onClick,
    trackedEvent,
    isDisabled,
  } = button

  const handleClick = () => {
    onClick && onClick()
    trackedEvent && analytics.track(trackedEvent.name, trackedEvent.parameters)
  }

  return (
    <>
      {linkHref ? (
        <Link
          href={linkHref}
          target={openInNewTab ? '_blank' : '_self'}
          onClick={() => handleClick()}
        >
          <Button
            type="button"
            size={size}
            variant={variant}
            icon={icon}
            textColor={textColor}
            fontWeight={fontWeight}
            fullWidth={isFullWidth}
            isHoverable={isHoverable}
            disabled={isDisabled}
          >
            {text}
          </Button>
        </Link>
      ) : (
        <Button
          type="button"
          size={size}
          variant={variant}
          icon={icon}
          textColor={textColor}
          fontWeight={fontWeight}
          fullWidth={isFullWidth}
          isHoverable={isHoverable}
          onClick={() => handleClick()}
          disabled={isDisabled}
        >
          {text}
        </Button>
      )}
    </>
  )
}
